var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-field-group',{attrs:{"language-prefix":"stockBatchReport.filters"}},[_c('StockBatchStatusSelect',{model:{value:(_vm.internalFilters.status),callback:function ($$v) {_vm.$set(_vm.internalFilters, "status", $$v)},expression:"internalFilters.status"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }